"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _identity = _interopRequireDefault(require("lodash/identity"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _popmotion = require("popmotion");

var _reactPose = _interopRequireDefault(require("react-pose"));

var _Track = _interopRequireDefault(require("./Track"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MarkerTrackAnimation = (0, _styledComponents["default"])((0, _reactPose["default"])(_react["default"].forwardRef(function (_ref, ref) {
  var style = _ref.style,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["style"]);
  delete props.x;
  delete props.offset;
  return _react["default"].createElement(_Track["default"], (0, _extends2["default"])({
    ref: ref,
    style: Object.assign({
      position: 'absolute'
    }, style)
  }, props));
}))({
  passive: {
    width: ['x', _identity["default"], true],
    left: ['offset', _identity["default"], true]
  }
}))(_templateObject(), function (_ref2) {
  var height = _ref2.height;
  return -((parseInt(height) || 2) - 2) / 2;
});

var MarkerTrack =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(MarkerTrack, _PureComponent);

  function MarkerTrack(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MarkerTrack);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MarkerTrack).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getParentValues", function () {
      var _this$props = _this.props,
          x = _this$props.x,
          offset = _this$props.offset;
      var values = {
        x: (0, _popmotion.value)(x.get() - offset.get()),
        offset: offset
      };
      _this.unsubscribeFromX = x.subscribe({
        update: function update(value) {
          return values.x.update(value - offset.get());
        }
      });
      _this.unsubscribeFromOffset = offset.subscribe({
        update: function update(value) {
          return values.x.update(x.get() - value);
        }
      });
      return values;
    });
    _this.state = {
      values: _this._getParentValues()
    };
    return _this;
  }

  (0, _createClass2["default"])(MarkerTrack, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.sliderLayout.width !== this.props.sliderLayout.width) {
        this.unsubscribeFromX();
        this.unsubscribeFromOffset();
        this.setState({
          values: this._getParentValues()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _extends2["default"])({}, this.props);
      var values = this.state.values;
      return _react["default"].createElement(MarkerTrackAnimation, (0, _extends2["default"])({}, props, {
        parentValues: values
      }));
    }
  }]);
  return MarkerTrack;
}(_react.PureComponent);

exports["default"] = MarkerTrack;